module.exports = __webpack_public_path__ + "img/FR15900.d794564f.png";